import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { Transaction } from "@onmo/graphql/graphql";
import { StaticImage } from "../StaticImage";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { Image } from "../../core/Image/Image";
import { getRewardImages, getRewardTitle } from "../../../models/rewardHistory";
import { useWalletConfig } from "../../../hooks/useWalletConfig";
import { useStyles } from "./TransactionHistoryCard.style";

interface ITransactionHistoryCardProps {
  rewardsHistory?: Transaction;
}

export const TransactionHistoryCard: FC<
  HTMLAttributes<HTMLDivElement> & ITransactionHistoryCardProps
> = (props) => {
  const classes = useStyles();
  const { rewardsHistory, className, ...otherProps } = props;
  const transactionHistoryImg = getRewardImages(rewardsHistory);
  const { spendableIcon } = useWalletConfig();

  return (
    <div {...otherProps} className={clsx(classes.root, className)}>
      <div className={classes.item}>
        <StaticImage
          src={transactionHistoryImg?.src}
          src2x={transactionHistoryImg?.src2x}
          src3x={transactionHistoryImg?.src3x}
          className={classes.itemImg}
        />
        <Typography variant={TypographyVariant.BodyB4Bold}>
          {getRewardTitle(rewardsHistory)}
        </Typography>
      </div>
      <div className={clsx(classes.item, classes.coinItem)}>
        <StaticImage
          src={spendableIcon.src}
          src2x={spendableIcon.src2x}
          src3x={spendableIcon.src3x}
          className={classes.coinImg}
        />
        <Typography variant={TypographyVariant.HeadingH6Bold}>
          {rewardsHistory?.amount}
        </Typography>
      </div>
    </div>
  );
};
